import * as apigw from "@/lib/apigw"

export const setMoviePlayDataDb = async (movieId?: string, playProgressRate?: number, opts?: any): Promise<any> => {
  const res = await apigw.request("/user/set-movie-play-data", { movieId, playProgressRate }, opts)
  return res
}
